<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("SettlementsShop.Fields.serviceChargeDetail") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
<!--      <v-row dense class="mx-5">-->
<!--        <v-col cols="12" sm="5">-->
<!--          <v-row dense align="center" class="pa-1">-->
<!--            <SearcherKeyword-->
<!--                ref="keyword"-->
<!--                v-model="Keyword"-->
<!--                @text="KeyWord = $event"-->
<!--                :label="$t('Keyword')"-->
<!--            />-->
<!--          </v-row>-->
<!--        </v-col>-->
<!--        <v-col cols="12" sm="2" align-self="center">-->
<!--          <v-tooltip bottom>-->
<!--            <template v-slot:activator="{ on, attrs }">-->
<!--              <v-btn-->
<!--                  v-bind="attrs"-->
<!--                  v-on="on"-->
<!--                  small-->
<!--                  text-->
<!--                  class="caption font-weight-bold grey&#45;&#45;text"-->
<!--                  color="primary"-->
<!--                  @click.stop="onSearch()"-->
<!--              >-->
<!--                <v-icon small class="pe-1">fa-search</v-icon>-->
<!--                {{ $t("Search.search") }}-->
<!--              </v-btn>-->
<!--            </template>-->
<!--            <span>{{ $t("Search.searchTip") }}</span>-->
<!--          </v-tooltip>-->
<!--        </v-col>-->
<!--      </v-row>-->
      <v-data-table
        :headers="headers"
        :items="settlementBills"
        :loading="loading"
        disable-sort
        multi-sort
        class="elevation-2 px-4 pt-1 sticky-table"
        height="340px"
        fixed-header
        :footer-props="$t('$config.footer-props')"
      >
        <template v-slot:item.fee="{ item }">
          {{ $t("Global.money") }}{{ item.fee | formatMoneyFloor(true) }}
        </template>
        <template v-slot:item.logistics_fee="{ item }">
          {{ $t("Global.money") }}{{ item.logistics_fee | formatMoneyFloor(true) }}
        </template>
        <template v-slot:item.service_charge="{ item }">
          {{ $t("Global.money") }}{{ item.service_charge | formatMoneyFloor(true) }}
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Settlements from "@/api/settlements";
// import SearcherKeyword from "@/components/plugins/SearcherKeyword";

export default {
  name: "SettlementServiceChargeDialog",

  props: {
    value: Number,
    options: Object,
  },

  components: {
    // SearcherKeyword,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("ShopBillView.Fields.bill_code"),
          align: "start",
          sortable: false,
          value: "bill_code",
        },
        {
          text: i18n.t("ShopBillView.Fields.fee"),
          align: "start",
          sortable: false,
          value: "fee",
        },
        {
          text: i18n.t("ShopBillView.Fields.logistics_fee"),
          align: "start",
          sortable: false,
          value: "logistics_fee",
        },
        {
          text: i18n.t("ShopBillView.Fields.service_charge"),
          align: "start",
          sortable: false,
          value: "service_charge",
        },
        {
          text: i18n.t("ShopBillView.Fields.org_code"),
          align: "center",
          sortable: false,
          value: "org_code",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    settlementBills: [],
    keyword: "",
  }),

  methods: {
    onSearch() {
      // this.keyword = this.KeyWord;
    },
    getServiceChargeBillsFromAPI() {
      let options = {
        id: this.value,
      }
      Settlements.getServiceChargeBills(options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.settlementBills = response.data.settlement_bills
            }
          }.bind(this)
      );
    },
  },

  watch: {
    dialog: {
      handler() {
        this.$emit("input", null);
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          this.dialog = true;
          this.getServiceChargeBillsFromAPI()
        }
      },
    },
  },
};
</script>